var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-dialog",
    {
      attrs: {
        icon: "/static/boleto.svg",
        title: "Você quer mesmo gerar o boleto?",
        visible: _vm.visible
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("p", [
            _vm._v(
              "Ao gerar o boleto não será mais possível pagar pelo cartão de crédito!"
            )
          ]),
          _vm._v(" "),
          _vm.displayPaymentVoucherNotice
            ? [
                _c("hr"),
                _vm._v(" "),
                _c("small", [
                  _vm._v(
                    "Você deverá enviar o comprovante de pagamento através de ticket pois o seu pedido tem menos de " +
                      _vm._s(_vm.daysToProvePayment) +
                      " dias úteis de antecedência."
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "btn-group" }, [
            _c(
              "div",
              {
                staticClass: "btn bg-purple-outline",
                on: {
                  click: function($event) {
                    _vm.$emit("cancelled")
                  }
                }
              },
              [_vm._v("Não, quero voltar")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn bg-purple",
                on: {
                  click: function($event) {
                    _vm.$emit("confirmed")
                  }
                }
              },
              [_vm._v("Sim, quero gerar o boleto")]
            )
          ])
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2219b43d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2219b43d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/BoletoConfirmation.vue
// module id = null
// module chunks = 